// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falJ: CreateIconOptions = {
  "displayName": "FALJ",
  "viewBox": "0, 0, 320, 512",
  "d": "M304 32c8.8 0 16 7.2 16 16l0 272c0 88.4-71.6 160-160 160S0 408.4 0 320l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c0 70.7 57.3 128 128 128s128-57.3 128-128l0-272c0-8.8 7.2-16 16-16z"
};
